import { useNavigate } from "react-router-dom";
import "../../pages/Users/Welcome/style.scss";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, IconButton } from "@mui/material";
const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer id="footer">
      {/* <div className="footer-newsletter">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <h4>Join Our Newsletter</h4>
              <p>
                Tamen quem nulla quae legam multos aute sint culpa legam noster
                magna
              </p>
              <form action="" method="post">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe" />
              </form>
            </div>
          </div>
        </div>
      </div> */}

      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3 col-md-6 footer-contact">
              <h3>Pellifix</h3>
              <p>
                No 16-13-359/1, haranathapuram, Vidhyanagar layout, Nellore,
                <br />
                SPSR Nellore, Andhra Pradesh,
                <br />
                524001
                <br />
                <br />
                <strong>Phone:</strong> +91 9655755476
                <br />
                <strong>Email:</strong> pellifix@gmail.com
                <br />
              </p>
            </div> */}

            <div className="col-lg-4 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="/">Home</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="/about-us">About us</a>
                </li>
                {/* <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="/services">Services</a>
                </li> */}
                <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="/terms-and-conditions">Terms of service</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="/privacy-policy">Privacy policy</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="/child-safety-standards">Child Safety Standards</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="/refund-policies">Refund Policies</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="#">Matches</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">Chat</a>
                </li>
                {/* <li>
                  <i className="bx bx-chevron-right"></i>
                  <a href="#">Horescope</a>
                </li> */}
              </ul>
            </div>

            <div className="col-lg-4 col-md-6 footer-links">
              <h4>Our Social Networks</h4>
              {/* <p>
                Cras fermentum odio eu feugiat lide par naso tierra videa magna
                derita valies
              </p> */}
              <div className="social-links mt-3">
                <IconButton
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/profile.php?id=100082580644187",
                      "_blank",
                    )
                  }
                >
                  <FacebookIcon
                    sx={{
                      color: "#FF8000",
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() =>
                    window.open("https://www.instagram.com/pellifix/", "_blank")
                  }
                >
                  <InstagramIcon
                    sx={{
                      color: "#FF8000",
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() =>
                    window.open("https://wa.me/7989530018", "_blank")
                  }
                >
                  <WhatsAppIcon
                    sx={{
                      color: "#FF8000",
                    }}
                  />
                </IconButton>
                {/* <IconButton>
                  <XIcon
                    sx={{
                      color: "#FF8000",
                    }}
                  />
                </IconButton> */}

                {/* <a href="https://twitter.com/home" className="twitter">
                  <i className="bx bxl-twitter"></i>
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100082580644187"
                  className="facebook"
                >
                  <i className="bx bxl-facebook"></i>
                </a>
                <a
                  href="https://instagram.com/pellifix?igshid=YmMyMTA2M2Y="
                  className="instagram"
                >
                  <i className="bx bxl-instagram"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <div className="copyright">
          &copy; Copyright
          <strong>
            <span>Pellifix</span>
          </strong>
          . All Rights Reserved
        </div>
      </div>
    </footer>
  );
};
export default Footer;
